import * as LandingPagesEffects from './landing-pages.effect';

export const effects = { ...LandingPagesEffects };
